import {
  actions,
  getUserConsumedContentAsync,
  getUserDailySessionsAsync,
  getUserMonthlySessionsAsync,
  getUserDevicesAsync,
  getUserSubscriptionHistoryAsync,
} from './slices';

export const UserAnalyticsActions = {
  ...actions,
  getUserConsumedContentAsync,
  getUserDailySessionsAsync,
  getUserMonthlySessionsAsync,
  getUserDevicesAsync,
  getUserSubscriptionHistoryAsync,
};
